(function () {
  if (window.__teInit) return; window.__teInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DRINKS = {
    espresso: { lvl: '64%', liq: '#4A2A16', name: 'Espresso' },
    americano: { lvl: '22%', liq: '#5A3620', name: 'Americano' },
    latte: { lvl: '16%', liq: '#B88A5E', name: 'Latte' }
  };

  function Machine(el) {
    this.el = el; this.t = el.querySelector('[data-txm-t]'); this.s = el.querySelector('[data-txm-s]'); this.busy = false; this.timers = [];
  }
  Machine.prototype.set = function (o) {
    var el = this.el;
    if (o.pod) el.setAttribute('data-pod', o.pod);
    if (o.temp) el.setAttribute('data-temp', o.temp);
    if (o.drink) el.setAttribute('data-drink', o.drink);
    var d = DRINKS[el.getAttribute('data-drink')] || DRINKS.espresso;
    el.style.setProperty('--liq', d.liq);
  };
  Machine.prototype.reset = function () {
    var el = this.el; this.timers.forEach(clearTimeout); this.timers = [];
    el.classList.remove('is-load', 'is-press', 'is-brew', 'is-done');
    el.style.setProperty('--lvl', '100%'); void el.offsetWidth;
    if (this.t) this.t.textContent = '0';
  };
  Machine.prototype.state = function (txt) { if (this.s) this.s.textContent = txt; };
  Machine.prototype.brew = function (o, done) {
    var m = this, el = this.el; o = o || {};
    m.reset(); m.set(o); m.busy = true;
    var d = DRINKS[el.getAttribute('data-drink')] || DRINKS.espresso;
    if (reduce) { el.style.setProperty('--lvl', d.lvl); el.classList.add('is-done'); if (m.t) m.t.textContent = '30'; m.state('Ready in about 30 seconds'); m.busy = false; done && done(); return; }
    var pod = el.getAttribute('data-pod');
    el.classList.add('is-load'); m.state(pod === 'ground' ? 'Adding ground coffee' : 'Adding a capsule');
    m.timers.push(setTimeout(function () { el.classList.remove('is-load'); el.classList.add('is-press'); m.state('Building to 17 bar'); }, 1000));
    m.timers.push(setTimeout(function () {
      el.classList.add('is-brew'); el.style.setProperty('--lvl', d.lvl); m.state('Brewing');
      var t0 = performance.now(), dur = 3200;
      (function tick(now) { var k = Math.min(1, (now - t0) / dur); if (m.t) m.t.textContent = Math.round(30 * k); if (k < 1) requestAnimationFrame(tick); })(t0);
    }, 1400));
    m.timers.push(setTimeout(function () {
      el.classList.remove('is-press'); el.classList.add('is-done');
      m.state(el.getAttribute('data-temp') === 'iced' ? 'Ready. Pour over ice' : 'Ready. Enjoy the crema');
      m.busy = false; done && done();
    }, 4800));
  };

  var machines = [];
  document.querySelectorAll('[data-txm]').forEach(function (el) { var m = new Machine(el); el.__m = m; machines.push(m); m.set({}); });

  var loop = [{ pod: 'capsule', temp: 'hot', drink: 'espresso' }, { pod: 'ground', temp: 'iced', drink: 'latte' }, { pod: 'capsule', temp: 'hot', drink: 'americano' }];
  var autoIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var m = e.target.__m; if (!m) return;
      if (e.isIntersecting && !m.loopT) {
        var i = 0;
        var run = function () { m.brew(loop[i % loop.length]); i++; m.loopT = setTimeout(run, reduce ? 999999 : 8200); };
        run();
      } else if (!e.isIntersecting && m.loopT) { clearTimeout(m.loopT); m.loopT = null; }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('[data-txm-auto]').forEach(function (el) { autoIO.observe(el); });

  document.querySelectorAll('[data-te-lab]').forEach(function (lab) {
    var el = lab.querySelector('[data-txm]'); if (!el) return; var m = el.__m;
    var opt = { pod: 'capsule', temp: 'hot', drink: 'espresso' };
    var rec = lab.querySelector('[data-te-recipe]');
    function recipe() {
      var d = DRINKS[opt.drink];
      var title = (opt.temp === 'iced' ? (opt.drink === 'espresso' ? 'Iced espresso' : 'Iced ' + d.name.toLowerCase()) : d.name) + ' · ' + (opt.pod === 'ground' ? 'ground coffee' : 'capsule');
      var s = [];
      s.push(opt.pod === 'ground' ? 'Fill the basket with finely ground coffee and level it.' : 'Pop a capsule into the capsule adapter.');
      s.push('Twist the brewing head closed and add ' + (opt.temp === 'iced' ? 'cold' : 'hot') + ' water to the tank.');
      s.push('Press the button. Your shot is ready in about 30 seconds.');
      if (opt.drink === 'espresso') s.push(opt.temp === 'iced' ? 'Pour it over ice and sip.' : 'Drink it while the crema is fresh.');
      if (opt.drink === 'americano') s.push(opt.temp === 'iced' ? 'Pour over ice and top up with cold water.' : 'Top up with hot water to taste.');
      if (opt.drink === 'latte') s.push(opt.temp === 'iced' ? 'Pour over ice and add cold milk.' : 'Add warm or frothed milk.');
      if (rec) rec.innerHTML = '<h3>' + title + '</h3><ol>' + s.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ol>';
    }
    lab.querySelectorAll('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-opt'); opt[k] = b.getAttribute('data-val');
        lab.querySelectorAll('[data-opt="' + k + '"]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        m.reset(); m.set(opt); m.state('Ready'); recipe();
        if (go) go.disabled = false;
      });
    });
    var go = lab.querySelector('[data-te-brew]');
    if (go) go.addEventListener('click', function () { go.disabled = true; m.brew(opt, function () { go.disabled = false; }); });
    recipe();
    var seen = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { m.brew(opt); seen.disconnect(); } }, { threshold: 0.5 });
    seen.observe(el);
  });

  document.querySelectorAll('[data-te-who]').forEach(function (w) {
    var tabs = w.querySelectorAll('[data-who]');
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-who');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        w.querySelectorAll('[data-who-img]').forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-who-img') === i); });
        w.querySelectorAll('[data-who-copy]').forEach(function (c) { c.hidden = c.getAttribute('data-who-copy') !== i; });
      });
    });
  });

  document.querySelectorAll('[data-te-calc]').forEach(function (c) {
    var price = parseInt(c.getAttribute('data-price'), 10) / 100, shot = 0.4, queue = 8;
    var n = c.querySelector('[data-c="n"]'), p = c.querySelector('[data-c="p"]');
    function q(k) { return c.querySelector('[data-o="' + k + '"]'); }
    function fmt(x) { return '£' + Math.round(x).toLocaleString('en-GB'); }
    function calc() {
      var cups = parseInt(n.value, 10), cp = parseFloat(p.value);
      q('n').textContent = cups; q('p').textContent = '£' + cp.toFixed(2);
      var per = Math.max(0.01, cp - shot), yr = cups * 52;
      q('weeks').textContent = Math.max(1, Math.ceil(price / (cups * per)));
      q('save').textContent = fmt(Math.max(0, yr * per - price));
      q('hours').textContent = Math.round(yr * queue / 60);
      var cafe = yr * cp, te = price + yr * shot, mx = Math.max(cafe, te);
      q('cafe').textContent = fmt(cafe); q('te').textContent = fmt(te);
      q('cafeBar').style.width = (cafe / mx * 100) + '%'; q('teBar').style.width = (te / mx * 100) + '%';
      var vc = q('vsCafe'); if (vc) vc.textContent = '£' + cp.toFixed(2);
    }
    n.addEventListener('input', calc); p.addEventListener('input', calc); calc();
  });

  document.querySelectorAll('[data-te-spec]').forEach(function (s) {
    var items = s.querySelectorAll('[data-i]');
    function on(i) { items.forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-i') === i); }); }
    items.forEach(function (x) { x.addEventListener('click', function () { on(x.getAttribute('data-i')); }); x.addEventListener('mouseenter', function () { on(x.getAttribute('data-i')); }); });
  });

  document.querySelectorAll('[data-te-rit]').forEach(function (r) {
    var esp = parseInt(r.getAttribute('data-esp'), 10), espP = parseInt(r.getAttribute('data-esp-price'), 10), off = parseInt(r.getAttribute('data-off'), 10);
    var opts = r.querySelectorAll('[data-head]'), head = null, headP = 0;
    function money(x) { return '£' + (x / 100).toFixed(x % 100 ? 2 : 0); }
    function sum() {
      r.querySelector('[data-s="head"]').textContent = money(headP);
      r.querySelector('[data-s="esp"]').textContent = money(espP);
      r.querySelector('[data-s="off"]').textContent = '−' + money(off);
      r.querySelector('[data-s="tot"]').textContent = money(headP + espP - off);
      var w = r.querySelector('[data-s="was"]'); if (w) w.textContent = money(headP + espP);
    }
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        opts.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        head = parseInt(b.getAttribute('data-head'), 10); headP = parseInt(b.getAttribute('data-price'), 10); sum();
      });
    });
    if (opts[0]) opts[0].click();
    var add = r.querySelector('[data-te-rit-add]'), err = r.querySelector('[data-te-rit-err]');
    if (add) add.addEventListener('click', function () {
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: head, quantity: 1 }, { id: esp, quantity: 1 }] }) })
        .then(function (res) { if (!res.ok) throw new Error('add'); window.location.href = '/cart'; })
        .catch(function () { add.disabled = false; add.textContent = 'Add both to bag'; if (err) err.hidden = false; });
    });
  });

  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.15 });
  document.querySelectorAll('.te-rv').forEach(function (el) { io.observe(el); });
  if (!reduce) {
    var par = document.querySelectorAll('[data-te-par]');
    if (par.length) window.addEventListener('scroll', function () {
      par.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - innerHeight / 2) * -0.06).toFixed(1) + 'px,0)'; });
    }, { passive: true });
  }
})();
